import React from "react";
import classNames from "classnames";
import { useRegistrationStore } from "@state/context/membership/registration-types/RegistrationStoreContext";
import { useFormContext } from "react-hook-form";
import { useRootAppStore } from "@hooks";
import { observer } from "mobx-react";
import ErrorBoundaryWithPropagation from "@components/boundary/ErrorBoundaryWithPropagation";

export default observer(function OnboardingRegistrationTabs() {
	const { trigger } = useFormContext();

	const { isIpRestricted } = useRootAppStore();

	const { currentStep, setCurrentStep, toggleStepSwitchFlag } =
		useRegistrationStore();

	const stepOneClasses = classNames(
		"counter counter--rounded--base counter--rounded counter--nero"
	);

	const stepTwoClasses = classNames(
		"counter counter--rounded--base counter--rounded",
		{
			"counter--medium": currentStep === 1,
			"counter--nero": currentStep === 2,
		}
	);

	return (
		<ErrorBoundaryWithPropagation
			componentName={"Desktop/OnBoardingRegistrationTabs.tsx"}
		>
			<div className="card--onboarding__steps">
				<div
					className={stepOneClasses}
					onClick={() => {
						setCurrentStep(1);
					}}
				>
					{currentStep === 1 ? (
						<>1</>
					) : (
						<i className="u-icon u-icon--tny u-icon--check u-color--core--snow"></i>
					)}
				</div>
				<button
					type="button"
					className={stepTwoClasses}
					disabled={currentStep === 2 || isIpRestricted}
					onClick={async () => {
						toggleStepSwitchFlag(true);
						const isValid = await trigger();

						if (isValid) {
							setCurrentStep(2, true);
						}
						toggleStepSwitchFlag(false);
					}}
				>
					2
				</button>
			</div>
		</ErrorBoundaryWithPropagation>
	);
});
